import { ResourceTypeLink } from "@evergis/api";

import { useLayerAccessDialog, useProjectAccessDialog, useTableAccessDialog } from "../../../hooks/useDialogs";

export const useAccessDialog = () => {
  const openProjectAccessDialog = useProjectAccessDialog();
  const openLayerAccessDialog = useLayerAccessDialog();
  const openTableAccessDialog = useTableAccessDialog();

  return (resourceName, resourceType) => {
    let openDialog;

    switch (resourceType) {
      case ResourceTypeLink.Project:
        openDialog = openProjectAccessDialog;
        break;
      case ResourceTypeLink.Layer:
        openDialog = openLayerAccessDialog;
        break;
      case ResourceTypeLink.Table:
        openDialog = openTableAccessDialog;
        break;
      default:
        openDialog = () => null;
    }

    openDialog([resourceName, resourceType]);
  };
};
